<template>
    <pre>{{ JSON.stringify(kioskDatas, null, 2) }}</pre>
</template>

<script>
import {getKioskByName} from '@/services/RequestService';
export default {
    props:{
        data:String
    },
   async mounted(){
        this.getKioskDatas(this.$props.data);
    },
    data:()=>({
        kioskDatas:null
    }),
    methods:{
        getKioskDatas:  async function(kioskName){
           this.kioskDatas = await getKioskByName(kioskName,true);
        }
    }
}
</script>